import classNames from 'classnames';
import { LinkWrapper } from '@reverse-hr/pattern-library';
import React from 'react';
import PropTypes from 'prop-types';
import { useStoreState } from 'easy-peasy';
import { selectorJobIsReverseMarketing } from '@model/Job/Job.selectors';

export const AppBanner = ({
  isLayoutSkyscraper,
  title,
  body,
  ctaLabel,
  ctaUrl,
  onClick,
}) => {
  const isJobReverseMarketing = useStoreState(selectorJobIsReverseMarketing);

  const wrapperClassNames = classNames('c-app-banner', {
    'c-app-banner--skyscreaper': isLayoutSkyscraper,
  });

  const bannerImagePathReverse = isJobReverseMarketing
    ? '/assets/images/banner-job-contract-marketing.png'
    : '/assets/images/banner-job-contract.jpg';

  const bannerImagePath = __ENVIRONMENT_CONFIG__.IS_THEME_AKI
    ? `/assets/images/aaron-king/profiling-contract-banner.png`
    : bannerImagePathReverse;

  const signatureImagePath = __ENVIRONMENT_CONFIG__.IS_THEME_AKI
    ? `/assets/images/aaron-king/profiling-contract-banner-sign.png`
    : '/assets/images/sign.png';

  const mainElementStyles = isLayoutSkyscraper
    ? null
    : {
        backgroundImage: `url(${__ENVIRONMENT_CONFIG__.PUBLIC_URL}${bannerImagePath})`,
      };

  const bannerDecorationSrc = `${__ENVIRONMENT_CONFIG__.PUBLIC_URL}${signatureImagePath}`;

  return (
    <div className={wrapperClassNames}>
      <div className="c-app-banner__decoration">
        <img src={bannerDecorationSrc} className="c-app-banner__image" alt="" />
      </div>

      <div className="c-app-banner__main" style={mainElementStyles}>
        <p className="c-app-banner__title">{title}</p>

        {!!body && <p className="c-app-banner__text">{body}</p>}

        <div className="c-app-banner__cta">
          <LinkWrapper
            download
            external
            type="simple-text"
            icon="icn-download"
            iconPosition="left"
            shadow
            target="_blank"
            rel="noreferrer"
            url={ctaUrl}
            label={ctaLabel}
            onClick={onClick}
          />
        </div>
      </div>
    </div>
  );
};

AppBanner.propTypes = {
  title: PropTypes.string.isRequired,
  ctaLabel: PropTypes.string.isRequired,
  ctaUrl: PropTypes.string.isRequired,
  onClick: PropTypes.func.isRequired,
  body: PropTypes.string,
  isLayoutSkyscraper: PropTypes.bool,
};
